export enum ApiErrorCodes {
  ACCESS_BLOCKED = "access_blocked",
  AUTHENTICATION_FAILED = "authentication_failed",
  USER_NOT_FOUND = "user_not_found",
  WRONG_CREDENTIALS = "wrong_credentials",
  EMAIL_ALREADY_EXIST = "email_already_exist",
  CANNOT_USER_SAME_PASSWORD = "cannot_user_same_password",
  INVALID = "invalid",
  CODE_NOT_FOUND = "code_not_found",
  INVALID_CODE = "invalid_code",
  INVALID_EMAIL = "invalid_email",
  HAS_PROMO_CODE = "has_promo_code",
  STRIPE_CARD_ERROR = "stripe_card_error",
  CREATE_SUBSCRIPTION_ERROR = "create_subscription_error",
  CHANGE_SUBSCRIPTION_ERROR = "change_subscription_error",
  CUSTOMER_HAS_THERAPIST = "customer_has_a_therapist",
  CUSTOMER_IS_NOW_IN_ASSIGMENT = "task_executed_other_node",
  CUSTOMER_HAS_NOT_SUBSCRIPTION = "customer_has_not_subscription",
  SCHEDULE_ALREADY_EXISTS = "schedule_already_exists",
  USER_EXISTS = "user_exists",
  NOT_ALLOWED = "not_allowed",
  USER_LOGED_OUT = "user_loged_out",
}
